import { getCache } from '../../../apollo/Cache';
import {
  CoreSocialProfileFieldsFragment,
  CoreSocialProfileFieldsFragmentDoc,
  SocialProfileFieldsFragment
} from '../../../models/graphql';

export type SocialProfileInputValue = {
  id: string;
  type: SocialProfileFieldsFragment['__typename'];
};
export const getCachedProfiles = (input: SocialProfileInputValue[]): CoreSocialProfileFieldsFragment[] => {
  return input.flatMap(({ id, type }) => {
    const cachedProfile = getCache().readFragment<CoreSocialProfileFieldsFragment>({
      id: `${type}:${id}`,
      fragment: CoreSocialProfileFieldsFragmentDoc
    });
    return cachedProfile ?? [];
  });
};
